import removeStrCommas from '../functions/removeStrCommas';
import percentToDecimal from '../functions/percentToDecimal';

const dynamicTransformation = (row, config, args) => {
    let temp = row; 
    // iterate over all elements of config 
    for (let i = 0; i < config.length; i++) { 
        // transformation logic for not required 
        if (config[i]['required'] === false && (temp[config[i]['columnid']] === '' )) {
            console.log('Transaformation ->', config[i]['columnid'], ':', temp[config[i]['columnid']]); 
            temp[config[i]['columnid']] = null; 
        }  
        // dynamic transformation logic 
        if (config[i]['transformation'] == 'id' && temp[config[i]['columnid']]) {
            temp[config[i]['columnid']] = temp[config[i]['columnid']]['id']; 
        }
        else if (config[i]['transformation'] == 'money' && temp[config[i]['columnid']]) { 
            temp[config[i]['columnid']] = removeStrCommas(temp[config[i]['columnid']]); 
        } 
        else if (config[i]['transformation'] == 'rate' && temp[config[i]['columnid']]) {
            // run transformation on incentive rates depending on rebate input type id (id of 0 is default and does not require transformation)
            if (args[config[i]['columnid']]['rateTypeId'] == 1 && temp[config[i]['columnid']] != null) { 
                // id == 1 for input as percent transformed to decimal 
                temp[config[i]['columnid']] = percentToDecimal(temp[config[i]['columnid']].replace('%', '')); 
            }
        }
        else if (config[i]['transformation'] == 'ach_numeric' && temp[config[i]['columnid']]) { 
            // determine whether to clear ach info based on payout method choice
            let clear = args[config[i]['columnid']]['clearachinfo']; 
            if (clear) {
                delete temp[config[i]['columnid']]; 
            }
        }   
        else if (config[i]['transformation'] == 'ach_alphanumeric' && temp[config[i]['columnid']]) { 
            // keep value only when payout method requires ach info (ACH type)
            if (!args?.[config[i]['columnid']]?.['requireachinfo']) {
                temp[config[i]['columnid']] = null; 
            }
        }
        else if (config[i]['transformation'] == 'ach_numeric_v2' && temp[config[i]['columnid']]) { 
            // determine whether to clear ach info based on payout method choice
            let clear = row['payoutmethodid']['clearachinfo'];  
            if (clear) {
                delete temp[config[i]['columnid']]; 
            }
        }   
        else if (config[i]['transformation'] == 'ach_id' && temp[config[i]['columnid']]) {
            // determine whether to clear ach info based on payout method choice
            let clear = args[config[i]['columnid']]['clearachinfo']; 
            if (clear) {
                delete temp[config[i]['columnid']]; 
            }
            else {
                if (temp[config[i]['columnid']] != null) {
                    temp[config[i]['columnid']] = temp[config[i]['columnid']]['id']; 
                }
            }
        }
        else if (config[i]['transformation'] == 'ach_id_v2' && temp[config[i]['columnid']]) {
            // determine whether to clear ach info based on payout method choice
            let clear = row['payoutmethodid']['clearachinfo'];  
            if (clear) {
                delete temp[config[i]['columnid']]; 
            }
            else {
                if (temp[config[i]['columnid']] != null) {
                    temp[config[i]['columnid']] = temp[config[i]['columnid']]['id']; 
                }
            }
        }
        else if (config[i]['transformation'] == 'label' && temp[config[i]['columnid']]) {
            temp[config[i]['columnid']] = temp[config[i]['columnid']]['label']; 
        }
        else if (config[i]['transformation'] == 'date_ovr_offset' && temp[config[i]['columnid']]) {
            let date = null; 
            if (temp[config[i]['columnid']]) {
                date = new Date(temp[config[i]['columnid']]); 
                date.setHours(date.getHours() - (date.getTimezoneOffset() / 60)); 
            }
            temp[config[i]['columnid']] = date; 
        }
        else if (config[i]['transformation'] == 'date_month' && temp[config[i]['columnid']]) {
            let date = null; 
            if (temp[config[i]['columnid']]) {
                date = new Date(temp[config[i]['columnid']]); 
                date.setDate(1); 
            }
            temp[config[i]['columnid']] = date; 
        }
    }
    // return transformed row 
    return temp;  
}

export default dynamicTransformation; 